import api from "./configuration";
import apiUrl from "./url";
export const RosterLineupAPI = {
	get: async (id) =>
		(
			await api.request({
				method: "GET",
				url: apiUrl + "/Rosters/" + id + "/lineup",
				useAuthInterceptor: true,
			})
		).data,
	addPlayer: async (id, playerId) =>
		(
			await api.request({
				method: "POST",
				url: apiUrl + "/Rosters/" + id + "/lineup/players/" + playerId,
				useAuthInterceptor: true,
			})
		).data,
	put: async (id, data, token, keepalive = false) => {
		const body = JSON.stringify(data);
		const response = await fetch(apiUrl + "/Rosters/" + id + "/lineup", {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + token,
			},
			body,
			keepalive: keepalive && new TextEncoder().encode(body).length < 60000,
		});
		if (!response.ok) {
			const error = new Error("Schieramento non salvato");
			error.response = {
				status: response.status,
				data: await response.json().catch(() => null),
			};
			throw error;
		}
		return response.json();
	},
};
